	export enum ScheduleOpenSlotInitialDurationEnum {
		_10Min = 1,
		_15Min = 2,
		_20Min = 3,
		_halfHour = 4,
		_1Hour = 5,
		_1AndHalfHours = 6,
		_2Hours = 7,
		_2AndHalfHours = 8,
		_3Hours = 9,
		_3AndHalfHours = 10,
		_4Hours = 11,
		_4AndHalfHours = 12,
		_5Hours = 13
	}
